<template>
  <div class="middle-bar animated fadeInLeftBig">
    <div class="mainDiv">
      <div class="b-line"></div>
      <div v-for="(item, i) in navList" :key="i">
        <div class="flex">
          <div class="bf" :class="i === active ? 'active' : ''"></div>
          <div
            class="item"
            :class="i === active ? 'active' : ''"
            @click="onChange(i)"
          >
            {{ item.name }}
          </div>
        </div>
        <template v-if="i === active">
          <div class="flex sub" v-for="(it2, i2) in item.children" :key="i2">
            <div class="bf" :class="it2.active === true ? 'active' : ''"></div>
            <div
              class="item"
              :class="it2.active === true ? 'active' : ''"
              @click="onChange2(i2)"
            >
              {{ it2.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: -1,
      navList: [
        {
          name: "示范村",
          children: [
            {
              name: "示范亮点行政村",
              active: true
            },
            {
              name: "净化整治阶段自然村",
              active: false
            },
            {
              name: "美化提升阶段自然村",
              active: false
            },
            {
              name: "文明达标阶段自然村",
              active: false
            }
          ]
        },
        // {
        //   name: "人居环境整治先行点"
        // },
        {
          // name: "扶贫项目",
          name: "巩固脱贫成效",
          children: [
            {
              name: "2021",
              active: true
            },
            {
              name: "2020",
              active: false
            },
            {
              name: "2019",
              active: false
            },
            {
              name: "2018",
              active: false
            }
          ]
        },
        {
          // name: "分镇情况"
          name: "全市各镇基本情况"
        }
      ]
    };
  },
  methods: {
    onChange(i) {
      if (this.active !== i) {
        this.active = i;
        /*         if (i > 0) {
          // 清空旧的选中
          if (this.active2 > -1) {
            this.active2 = -1;
          }
          this.$bus.$emit("ncchange", this.navList[i]["name"], i);
        } else {
          this.active2 = 0;
          this.$bus.$emit(
            "ncchange",
            this.navList[0]["children"][0]["name"],
            i
          );
        } */
        if (this.navList[i]["children"]) {
          // 如果有子栏目
          let index = this.navList[i]["children"].findIndex(e => {
            return e.active === true;
          });
          this.$bus.$emit(
            "ncchange",
            this.navList[i]["children"][index]["name"],
            i
          );
        } else {
          //无子栏目
          this.$bus.$emit("ncchange", this.navList[i]["name"], i);
        }
      }
    },
    onChange2(i) {
      /* if (this.active2 !== i) {
        this.active2 = i;
        this.$bus.$emit("ncchange", this.navList[0]["children"][i]["name"], 0);
      } */
      if (this.navList[this.active]["children"][i]["active"] !== true) {
        // this.active2 = i;
        this.navList[this.active]["children"].forEach(e => {
          if (e.active) {
            e.active = false;
          }
        });
        this.navList[this.active]["children"][i]["active"] = true;
        this.$bus.$emit(
          "ncchange",
          this.navList[this.active]["children"][i]["name"],
          this.active
        );
      }
    }
  },
  mounted() {
    if (this.active === -1) {
      this.onChange(0);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/granary/choose'
</style>
